export default "__VITE_ASSET__D5XGO1$V__"